import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  listarCapitulos(page = 1, size = 10, filtros = {}) {
    const params = new URLSearchParams();
    if (filtros.glosa) params.append('glosa', filtros.glosa);
    if (filtros.idCurso) params.append('idCurso', filtros.idCurso);
    if (filtros.idAsignatura) params.append('idAsignatura', filtros.idAsignatura);
    const qs = params.toString();
    return axios.get(
      `${API_URL}/Capitulo/v1/list/${page}/${size}${qs ? `?${qs}` : ''}`
    );
  },

  guardarCapitulo(payload) {
    return axios.post(`${API_URL}/Capitulo/v1`, payload);
  },

  actualizarCapitulo(id, payload) {
    return axios.put(`${API_URL}/Capitulo/v1/${id}`, payload);
  },

  listarUnidades(page = 1, size = 10, filtros = {}) {
    const params = new URLSearchParams();
    if (filtros.glosa) params.append('glosa', filtros.glosa);
    if (typeof filtros.vigente === 'boolean') params.append('vigente', filtros.vigente);
    const qs = params.toString();
    return axios.get(
      `${API_URL}/EjeTematico/v1/list/${page}/${size}${qs ? `?${qs}` : ''}`
    );
  },

  guardarUnidad(payload) {
    return axios.post(`${API_URL}/EjeTematico/v1`, payload);
  },

  actualizarUnidad(id, payload) {
    return axios.put(`${API_URL}/EjeTematico/v1/${id}`, payload);
  },

  obtenerUnidadPorId(id) {
    return axios.get(`${API_URL}/EjeTematico/v1/${id}`);
  },
};
